export const moviePhotoSize = 'w342'
export const actorPhotoSize = 'w45'
